// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import request from '@/utils/request';

/**
 * 新增商品
 * @param pram
 */
export function productCreateApi(data) {
  return request({
    url: '/admin/store/product/save',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑商品
 * @param pram
 */
export function productUpdateApi(data) {
  return request({
    url: '/admin/store/product/update',
    method: 'POST',
    data: data
  });
}

/**
 * 商品详情
 * @param pram
 */
export function productDetailApi(id) {
  return request({
    url: "/admin/store/product/info/".concat(id),
    method: 'GET'
  });
}

/**
 * 删除商品
 * @param pram
 */
export function productDeleteApi(id, type) {
  return request({
    url: "/admin/store/product/delete/".concat(id),
    method: 'get',
    params: {
      type: type
    }
  });
}

/**
 * 商品列表 表头数量
 */
export function productHeadersApi() {
  return request({
    url: '/admin/store/product/tabs/headers',
    method: 'GET'
  });
}

/**
 * 商品列表
 * @param pram
 */
export function productLstApi(params) {
  // console.log('params', params)
  return request({
    url: '/admin/store/product/list',
    method: 'GET',
    params: params
  });
}
/**
 * 商品分类
 * @param pram
 */
export function categoryApi(params) {
  return request({
    url: '/admin/category/list/tree',
    method: 'GET',
    params: params
  });
}
/**
 * 商品上架
 * @param pram
 */
export function putOnShellApi(id) {
  return request({
    url: "/admin/store/product/putOnShell/".concat(id),
    method: 'GET'
  });
}
/**
 * 商品下架
 * @param pram
 */
export function offShellApi(id) {
  return request({
    url: "/admin/store/product/offShell/".concat(id),
    method: 'GET'
  });
}
/**
 * 商品规格 列表
 * @param pram
 */
export function templateListApi(params) {
  return request({
    url: '/admin/store/product/rule/list',
    method: 'GET',
    params: params
  });
}
/**
 * 商品规格 删除
 * @param pram
 */
export function attrDeleteApi(id) {
  return request({
    url: "/admin/store/product/rule/delete/".concat(id),
    method: 'get'
  });
}
/**
 * 商品规格 新增
 * @param pram
 */
export function attrCreatApi(data) {
  return request({
    url: '/admin/store/product/rule/save',
    method: 'POST',
    data: data
  });
}
/**
 * 商品规格 编辑
 * @param pram
 */
export function attrEditApi(data) {
  return request({
    url: '/admin/store/product/rule/update',
    method: 'POST',
    data: data
  });
}
/**
 * 商品规格 详情
 * @param pram
 */
export function attrInfoApi(id) {
  return request({
    url: "admin/store/product/rule/info/".concat(id),
    method: 'GET'
  });
}
/**
 * 商品评论 列表
 * @param pram
 */
export function replyListApi(params) {
  return request({
    url: '/admin/store/product/reply/list',
    method: 'GET',
    params: params
  });
}
/**
 * 商品评论 新增
 * @param pram
 */
export function replyCreatApi(data) {
  return request({
    url: '/admin/store/product/reply/save',
    method: 'POST',
    data: data
  });
}
/**
 * 商品评论 编辑
 * @param pram
 */
export function replyEditApi(data) {
  return request({
    url: '/admin/store/product/reply/update',
    method: 'POST',
    data: data
  });
}
/**
 * 商品评论 详情
 * @param pram
 */
export function replyInfoApi(id) {
  return request({
    url: "/admin/store/product/reply/info/".concat(id),
    method: 'GET'
  });
}
/**
 * 商品评论 删除
 * @param pram
 */
export function replyDeleteApi(id) {
  return request({
    url: "/admin/store/product/reply/delete/".concat(id),
    method: 'GET'
  });
}

/**
 * 商品评论 回复
 * @param pram
 */
export function replyCommentApi(data) {
  return request({
    url: "/admin/store/product/reply/comment",
    method: 'post',
    data: data
  });
}

/**
 * 商品评论 导出
 * @param pram
 */
export function productExportApi(params) {
  return request({
    url: "/admin/export/excel/product",
    method: 'get',
    params: params
  });
}

/**
 * 商品复制 99Api
 * @param pram
 */
export function importProductApi(params) {
  return request({
    url: "/admin/store/product/importProduct",
    method: 'post',
    params: params
  });
}

/**
 * 商品复制 一号通
 * @param pram
 */
export function copyProductApi(data) {
  return request({
    url: "/admin/store/product/copy/product",
    method: 'post',
    data: data
  });
}

/**
 * 恢复
 * @param pram
 */
export function restoreApi(id) {
  return request({
    url: "/admin/store/product/restore/".concat(id),
    method: 'get'
  });
}

/**
 * 商品列表 导出
 * @param pram
 */
export function productExcelApi(params) {
  return request({
    url: "/admin/export/excel/product",
    method: 'get',
    params: params
  });
}

/**
 * 商品列表 获取复制商品配置
 * @param pram
 */
export function copyConfigApi() {
  return request({
    url: "/admin/store/product/copy/config",
    method: 'post'
  });
}

/**
 * 订单数据 导出
 * @param pram
 */
export function orderExcelApi(params) {
  return request({
    url: "/admin/export/excel/order",
    method: 'get',
    params: params
  });
}

/**
 * 商品区域模板
 */
// 模板新增
export function addProductAreaTemplate(data) {
  return request({
    url: "/admin/store/product/template/save",
    method: 'post',
    data: data
  });
}

// 模板修改
export function updateProductAreaTemplate(data) {
  return request({
    url: "/admin/store/product/template/update",
    method: 'post',
    data: data
  });
}

// 模板列表
export function getProductAreaTemplateList(data) {
  return request({
    url: "/admin/store/product/template/list",
    method: 'GET',
    params: data
  });
}

// 模板删除
export function delProductAreaTemplate(data) {
  return request({
    url: "/admin/store/product/template/delete",
    method: 'GET',
    params: data
  });
}
// 商品审核拒绝
export function updateProductAuditRejet(data) {
  return request({
    url: "/admin/store/product/auditRejet",
    method: 'post',
    data: data
  });
}

// 商品审核通过
export function updateProductAuditPass(id, price) {
  return request({
    url: "/admin/store/product/auditPass/".concat(id),
    method: 'get',
    param: {
      price: price
    }
  });
}

// 批量商品审核通过
export function updateProductAuditPassAll(data) {
  return request({
    url: "/admin/store/product/auditPass/all",
    method: 'get',
    params: data
  });
}

// 获取商品的零售价
export function productFindPriceByCost(data) {
  return request({
    url: "/admin/store/product/findPriceByCost",
    method: 'get',
    params: data
  });
}
export var updateProductPrice = function updateProductPrice(data) {
  return request({
    url: '/admin/store/product/updatePrice',
    method: 'POST',
    data: data
  });
};
export var updateBuyTypeApi = function updateBuyTypeApi(data) {
  return request({
    url: '/admin/store/product/updateBuyType',
    method: 'POST',
    data: data
  });
};
export var updatePlatformAddPrice = function updatePlatformAddPrice(data) {
  return request({
    url: '/admin/store/product/updatePlatformAddPrice',
    method: 'POST',
    data: data
  });
};
export var updatePrice = function updatePrice(data) {
  return request({
    url: '/admin/store/product/updatePrice',
    method: 'POST',
    data: data
  });
};
export var detailList = function detailList(data) {
  return request({
    url: '/admin/finance/income/detailList',
    method: 'GET',
    params: data
  });
};
// 查询列表品牌
export var brandList = function brandList() {
  return request({
    url: '/admin/store/product/getProductBrand',
    method: 'GET'
  });
};

// 商品价格明细
export var getProductPriceDetails = function getProductPriceDetails(data) {
  return request({
    url: '/admin/store/product/getProductPriceDetails',
    method: 'POST',
    data: data
  });
};

// 易宝状态更新
export var yopSettleOrderQuery = function yopSettleOrderQuery(params) {
  return request({
    url: '/admin/company/yopSettleOrderQuery',
    method: 'GET',
    params: params
  });
};

// 发票列表
export var editFzPrice = function editFzPrice(data) {
  return request({
    url: '/admin/finance/brokerage/editFzPrice',
    method: 'POST',
    data: data
  });
};

// 发票列表
export var applyFz = function applyFz(params) {
  return request({
    url: '/admin/company/applyFz',
    method: 'GET',
    params: params
  });
};

//产品报价列表 post /api/admin/brandMemberProduct/pageBrandMemberProduct  
export var pageBrandMemberProduct = function pageBrandMemberProduct(data) {
  return request({
    url: '/admin/brandMemberProduct/pageBrandMemberProduct',
    method: 'POST',
    data: data
  });
};

//记录列表 post /api/admin/brandMemberProduct/pageBrandMemberProductLog
export var pageBrandMemberProductLog = function pageBrandMemberProductLog(data) {
  return request({
    url: '/admin/brandMemberProduct/pageBrandMemberProductLog',
    method: 'POST',
    data: data
  });
};

//导入产品报价表 /api/admin/brandMemberProduct/importBrandMemberProduct/{type}  
export var importBrandMemberProduct = function importBrandMemberProduct(type, data) {
  return request({
    url: "/admin/brandMemberProduct/importBrandMemberProduct/".concat(type),
    method: 'POST',
    data: data
  });
};

//删除产品报价表 /api/admin/brandMemberProduct/deleteBrandMemberProduct
export var deleteBrandMemberProduct = function deleteBrandMemberProduct(data) {
  return request({
    url: '/admin/brandMemberProduct/deleteBrandMemberProduct',
    method: 'POST',
    data: data
  });
};